export const Icons = {
    lock: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 5a3 3 0 0 1 6 0v3H9V7zm3 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
        </svg>
    `,
    /** Silhouette fusée : cône + corps + ailerons + flamme */
    rocket: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2L6.5 13H8v9h8v-9h1.5L12 2z"/>
            <path d="M6.5 13L3.5 17.5h3.2l.8-4.5zM17.5 13l3 4.5h-3.2l-.8-4.5z" opacity="0.92"/>
            <path d="M10.2 14.5h3.6v2.6h-3.6z" opacity="0.28"/>
            <path d="M12 20.2l-2 3.3h4L12 20.2z" opacity="0.85"/>
        </svg>
    `,
    gift: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.5 2.5 0 0 0-5 0c0 .35.07.69.18 1H11c.11-.31.18-.65.18-1a2.5 2.5 0 0 0-5 0c0 .35.07.69.18 1H4a2 2 0 0 0-2 2v2a2 2 0 0 0 1 1.72V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.28A2 2 0 0 0 22 10V8a2 2 0 0 0-2-2zM12 19H6v-7h6v7zm7 0h-6v-7h6v7z" />
        </svg>
    `,
    star: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
    `,
    heart: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
    `,
    coin: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.58-1.07-2.77-2.73-3.14V5h-1.87v1.54c-1.63.31-2.92 1.33-2.92 2.89 0 1.83 1.51 2.74 3.72 3.26 2.04.48 2.45 1.13 2.45 1.91 0 1.1-.96 1.63-2.32 1.63-1.68 0-2.35-.74-2.45-1.64h-1.73c.12 1.81 1.32 2.87 3.03 3.2v1.57h1.87V17.5c1.63-.29 2.92-1.25 2.92-2.9 0-2.02-1.71-2.93-3.72-3.45z" />
        </svg>
    `,
    trophy: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M19,5H17.5C17.5,3.3 16.2,2 14.5,2H9.5C7.8,2 6.5,3.3 6.5,5H5C3.3,5 2,6.3 2,8V9C2,10.7 3.3,12 5,12H6.5C7.3,13.6 8.7,14.8 10.5,15.1V18H9C7.3,18 6,19.3 6,21V22H18V21C18,19.3 16.7,18 15,18H13.5V15.1C15.3,14.8 16.7,13.6 17.5,12H19C20.7,12 22,10.7 22,9V8C22,6.3 20.7,5 19,5ZM5,10C4.4,10 4,9.6 4,9V8C4,7.4 4.4,7 5,7H6.5V10H5ZM20,9C20,9.6 19.6,10 19,10H17.5V7H19C19.6,7 20,7.4 20,8V9Z" />
        </svg>
    `,
    /** Bar chart — better visual match for “global / leaderboard” than a cup trophy */
    leaderboardBars: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 17h2v-6H7v6zm4 0h2V7h-2v10zm4 0h2v-4h-2v4zm4 0h2V3h-2v14z"/>
        </svg>
    `,
    skull: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M12 2a9 9 0 0 0-9 9c0 4.17 2.84 7.67 6.69 8.69L10 22h4l.31-2.31C18.16 18.67 21 15.17 21 11a9 9 0 0 0-9-9zm-3 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
        </svg>
    `,
    energy: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
    `,
    gamepad: (size = 20, color = 'currentColor') => `
        <svg style="width:${size}px;height:${size}px;vertical-align:middle;fill:${color}" viewBox="0 0 24 24">
            <path d="M21,6H3A2,2 0 0,0 1,8V16A2,2 0 0,0 3,18H21A2,2 0 0,0 23,16V8A2,2 0 0,0 21,6M6,15H4V13H2V11H4V9H6V11H8V13H6V15M11,11H13V13H11V11M16,15H14V13H16V15M19,13H17V11H19V13Z" />
        </svg>
    `
};
